// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".previewCode .previewCodeTool {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 5px 0;\n  margin-top: -40px;\n}\n.previewCode .tab-info {\n  height: 50vh;\n  background: #fff;\n  padding: 0 20px;\n  overflow-y: scroll;\n}", ""]);
// Exports
module.exports = exports;
